import { postApi } from '../../api';
import * as UserActions from '../user/actions';



export async function getOfferingJSON(token, slug,env) {
  const apiResponse = await postApi.searchOffering(token, slug,env);
  const respJson = await apiResponse.json();
  let obj = {};
  if (apiResponse.status === 200) {
    obj['status'] = true;
    obj['data'] =respJson;
  } else {
    obj['status'] = false;
    obj['msg'] =respJson;
  }
  return obj;
}
export async function getResourceJSON(token, slug,env) {
  const apiResponse = await postApi.searchResource(token, slug,env);
  const respJson = await apiResponse.json();
  let obj = {};
  if (apiResponse.status === 200) {
    obj['status'] = true;
    obj['data'] =respJson;
  } else {
    obj['status'] = false;
    obj['msg'] =respJson;
  }
  return obj;
}

//Sales Template
export async function getSalesTemplateJSON(token, slug,env) {
  const apiResponse = await postApi.searchSalesTemplate(token, slug,env);
  const respJson = await apiResponse.json();
  let obj = {};
  if (apiResponse.status === 200) {
    obj['status'] = true;
    obj['data'] =respJson;
  } else {
    obj['status'] = false;
    obj['msg'] =respJson;
  }
  return obj;
}

//IoTWG Materials
export async function getIoTWGMaterialJSON(token, slug,env) {
  const apiResponse = await postApi.searchIoTWGMaterial(token, slug,env);
  const respJson = await apiResponse.json();
  let obj = {};
  if (apiResponse.status === 200) {
    obj['status'] = true;
    obj['data'] =respJson;
  } else {
    obj['status'] = false;
    obj['msg'] =respJson;
  }
  return obj;
}

//IoT Frameworks
export async function getIoTFrameworkJSON(token, slug,env) {
  const apiResponse = await postApi.searchIoTFramework(token, slug,env);
  const respJson = await apiResponse.json();
  let obj = {};
  if (apiResponse.status === 200) {
    obj['status'] = true;
    obj['data'] =respJson;
  } else {
    obj['status'] = false;
    obj['msg'] =respJson;
  }
  return obj;
}

export async function getAnyPostsJSON(token, page,formdata) {
  const apiResponse = await postApi.searchPosts(token, page, formdata);
  const respJson = await apiResponse.json();
  console.log(respJson);
  let obj = {};
  if (apiResponse.status === 200) {
    obj['status'] = true;
    obj['data'] =respJson;
  } else {
    obj['status'] = false;
    obj['msg'] =respJson;
  }
  return obj;
}


export function searchPostsJson(token, page, formdata) {
  return async dispatch => {
    try {
      dispatch({ type: 'RESET_POSTS' });
      dispatch({ type: 'LOADING_POSTS', loading: true, error: '' });

      const apiResponse = await postApi.searchPosts(token, page, formdata);
      const respJson = await apiResponse.json();
      if (apiResponse.status === 200) {
        let obj = {};
        obj['max_num_pages'] = respJson['max_num_pages'];
        obj['currentpage'] = respJson['currentpage'];
        obj['selected'] = respJson['selected'];
        obj['data'] = respJson['data'];
        dispatch({ type: 'SET_POSTS', data: obj });
        dispatch({ type: 'LOADING_POSTS', loading: false, error: '' });

      } else if (apiResponse.status === 403) {
        dispatch({ type: 'LOADING_POSTS', loading: false, error: '' });
        UserActions.logoutWithDispatch(dispatch);

      } else {
        dispatch({ type: 'LOADING_POSTS', loading: false, error: respJson });
      }
    } catch (error) {
      dispatch({ type: 'LOADING_POSTS', loading: false, error: error });
    }

  }
}



